export default __webpack_public_path__ + "static/media/ZingCreateActionH.e2b428a6.png";